import { PROGRAM_TYPES } from 'site-modules/shared/components/incentives/incentives-wizard/constants/program-types';

export function isTaxCreditRebate(incentive) {
  const { programType } = incentive;
  return programType === PROGRAM_TYPES.TAX_CREDIT;
}
